<template>
  <b-container class="page-container">
    <Breadcrumbs :currentpage="$t('setup-new-password')" />
    <h1 class="text-center">{{ $t('setup-new-password') }}</h1>
    <b-alert v-if="invalidLink || !code" show variant="warning">
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fas"
        data-icon="exclamation-circle"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        class="svg-inline--fa fa-exclamation-circle fa-w-16 fa-5x"
      >
        <path
          fill="currentColor"
          d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
          class=""
        ></path></svg
      >{{ $t('password-reset-link-expired-invalid') }}
      <router-link :to="{ name: 'forgotPassword' }">{{
        $t('new-password-lowercase')
      }}</router-link
      >.
    </b-alert>

    <p v-if="!invalidLink && code">{{ $t('fill-in-new-password-below') }}</p>

    <b-row v-if="!invalidLink && code">
      <b-col sm="12" class="mb-3"></b-col>
      <b-col cols="12">
        <hr />
        <password-helper-block />
      </b-col>

      <b-col sm="12" md="6" lg="4">
        <b-card>
          <b-form @submit.prevent="resetPasswordSubmit">
            <b-form-group
              id="input-group-1"
              :label="$t('new-password')"
              label-for="input-1"
            >
              <b-form-input
                id="input-1"
                v-model="form.password"
                :state="passwordValidation"
                type="password"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-1"
              :label="$t('repeat-new-password')"
              label-for="input-1"
            >
              <b-form-input
                id="input-1"
                v-model="form.confirmPassword"
                :state="passwordConfirmState && passwordValidation"
                type="password"
                required
              ></b-form-input>
            </b-form-group>
            <b-row>
              <b-col cols="12">
                <b-button
                  :disabled="!passwordConfirmState || !passwordValidation"
                  class="mb-2"
                  type="submit"
                  variant="primary"
                >
                  {{ $t('change-password') }}
                  <icon-spinner v-if="requesting" class="fa-spin" />
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { setNewPassword } from '@/services/AuthorizationService'
import Breadcrumbs from '@/components/header/BreadCrumbs'
import PasswordHelperBlock from '@/components/global/PasswordHelperBlock.vue'
import IconSpinner from '@/components/icons/IconSpinner'
export default {
  components: {
    IconSpinner,
    Breadcrumbs,
    PasswordHelperBlock
  },
  data() {
    return {
      form: {
        password: '',
        confirmPassword: ''
      },
      invalidLink: false,
      success: false,
      requesting: false,
      wrongPassword: false
    }
  },
  computed: {
    code: function() {
      return this.$route.query.code || false
    },
    passwordValidation() {
      let password = this.form.password
      if (password != '') {
        if (password.length < 8) {
          return false
        }

        if (!password.match(/[!@$%&\-+*()&^]/)) return false
        if (!password.match(/[0-9]/)) return false
        if (!password.match(/[a-z]/)) return false
        if (!password.match(/[A-Z]/)) return false
        if (!/^([0-9a-zA-Z!@$%&\-+*()&^]*)$/.exec(password)) return false

        return true
      }

      return null
    },

    passwordConfirmState() {
      if (this.form.password != '') {
        if (this.form.password == this.form.confirmPassword) {
          return true
        }
        return false
      }
      return null
    }
  },
  watch: {
    form: {
      handler() {
        if (this.form.password != this.confirmPassword) {
          this.wrongPassword = true
        } else {
          this.wrongPassword = false
        }
      },
      deep: true
    }
  },
  methods: {
    async resetPasswordSubmit() {
      this.requesting = true

      const result = await setNewPassword({
        password: this.form.password,
        confirmPassword: this.form.confirmPassword,
        code: this.code
      })

      if (
        result.data != null &&
        result.data != 'FAILURE' &&
        result.data == 'SUCCESS'
      ) {
        this.success = true
        this.$router.push({ name: 'login', query: { passwordReset: true } })
      } else {
        this.invalidLink = true
      }

      this.requesting = false
    }
  }
}
</script>
<style scoped lang="scss">
a.btn {
  text-decoration: none;
}
</style>
